import React, {useEffect, useRef} from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import Slider from "react-slick";

import styles from "./horizontal-slider.module.scss";

function HorizontalSlider(props) {
  const {className, children, ...restProps} = props;
  const containerRef = useRef(null);
  const sliderRef = useRef(null);

  useEffect(() => {
    const slide = (y) => {
      if (y < 0) {
        return sliderRef.current.slickNext();
      } else {
        return sliderRef.current.slickPrev();
      }
    };
    const containerEl = containerRef.current;
    const listener = containerEl.addEventListener(`wheel`, (e) => {
      e.preventDefault();
      slide(e.wheelDelta);
    });
    return () => {
      containerEl.removeEventListener(`wheel`, listener);
    };
  }, []);

  return (
    <div ref={containerRef} className={styles.root}>
      <Slider
        ref={sliderRef}
        className={classNames(styles.slider, className)}
        scrolling={true}
        {...restProps}
      >
        {children}
      </Slider>
    </div>
  );
}

HorizontalSlider.propTypes = {
  className: PropTypes.string,
  children: PropTypes.array
};

export default HorizontalSlider;
